import { useContext, useEffect } from 'react';
import { UnsavedChangesContext } from './use-unsaved-changes';
export var useUnsavedChangesWarning = function useUnsavedChangesWarning(isFormDirty) {
  var _useContext = useContext(UnsavedChangesContext),
      isDirty = _useContext.isDirty,
      setDirtyState = _useContext.setDirtyState;

  useEffect(function () {
    return setDirtyState(isFormDirty);
  }, [isFormDirty]);
  return {
    isDirty: isDirty,
    setDirtyState: setDirtyState
  };
};